import React, { useState } from "react";
import Button from "@mui/material/Button";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Axios from "axios";
import moment from "moment";
import { API_URL_LMS} from "../../../../Constant/index";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  // GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

import {
  DATE_FORMAT,
  millisecondsToStringDate
} from "../../../../_helpers/commonFunctions";

import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import Popup from "../../../../components/Popup/Popup";
import AddDealer from "./AllocationInventoryEdit";
// import DeleteDealer from "./DeleteDealer";
// import "./dealerRelationShip.scss";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import { getDealerRetationShipListAction } from "../../../../_actions/subDealer.action";
import {
  convertToCurrencyFormat,
  convertToCurrencyFormatQuantaty,
  DataFormat
} from "../../../../_helpers";
import { API_URL_ADMIN } from "../../../../Constant/index";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import { onExportExcel } from "../../../../_helpers/exportExcel";

const rows = [
  {
    id: 1,
    aaal: "6526634",
    company: "SCCC",
    billingyear: "2014",
    bmonth: "05",
    pno: "635634",
    pname: "INSEE SUPER-BAG40 KG",
    qty: "200.00",
    rqty: "00.00",
    mAllocated: "00.00",
    aAllocated: "100.00",
    sumA: "100.00",
    EDate: "2014-10-5",
  },
  {
    id: 2,
    aaal: "97388",
    company: "SCCC",
    billingyear: "2016",
    bmonth: "07",
    pno: "45454",
    pname: "INSEE SUPER-BAG 60 KG",
    qty: "100.00",
    rqty: "300.00",
    mAllocated: "10.00",
    aAllocated: "100.00",
    sumA: "100.00",
    EDate: "2015-10-5",
  },
  {
    id: 1,
    aaal: "6526634",
    company: "SCCC",
    billingyear: "2014",
    bmonth: "05",
    pno: "635634",
    pname: "INSEE SUPER-BAG40 KG",
    qty: "200.00",
    rqty: "00.00",
    mAllocated: "00.00",
    aAllocated: "100.00",
    sumA: "100.00",
    EDate: "2014-10-5",
  },
];

const AllocationInventoryList = (props) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [isdelete, setIsdelete] = useState(false);
  const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState(null);
  const [headerName, setHeaderName] = useState("Add Contact");
  const [tableData, setTableData] = useState([]);
  const [gridData, setGridData] = useState([]);
  const dealerListWithRelationship = useSelector(
    (state) => state.dealerListWithRelationship
  );
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [pageSize, setPageSize] = React.useState(25);
  const { dataTable } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [exportState, setExportState] = useState("Export");
  // let [searchParams, setSearchParams] = useSearchParams();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const subdealerNumber = params.get("subDelearNumber");
  const [loading, setLoading]=React.useState(false)
  const [searchedRows, setSearchedRows] = useState(null)
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    message: "",
    severity: "",
    open: false,
  });

  React.useEffect(() => {
    setLoading(true)
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };  
    Axios.get(API_URL_LMS+`loyalty/inventory-billing?productCode=${props.itemDetails.productCode}&customerId=${props.itemDetails.customerId}&billingMonths=${props.itemDetails.billingMonth}&billingYear=${props.itemDetails.billingYear}&expiryDate=${props.itemDetails.expirationDate}`,requestOptions)
      .then((response) => {
        setLoading(false)
          if(response.data.status===200)
          {
            setTableData(response.data.data)   

          }else{
            setTableData([])
          }
        
      })
      .catch((error) => {
        
      });
  }, []);

  const columns = [
    {
      field: "billingNumber",
      headerName: "Billing Number",
      align: "center",
      headerAlign: "center",
      width: 190,
    },
    {
      field: "billingQty",
      headerName: "Billing Quantity",
      headerAlign: "center",
      align: "right",
      width: 190,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return <div>{row.billingQty != null ? convertToCurrencyFormatQuantaty(row.billingQty) : null}</div>;
      },
    },
    {
      field: "billingDate",
      headerName: "Billing Date",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "date",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    {
      field: "productCode",
      headerName: "Product Number",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: ({ row }) => {
        return <>{row.productCode ? DataFormat(row.productCode) : ""}</>;
      },
    },
    {
      field: "productName",
      headerName: "Product Name",
      headerAlign: "center",
      align: "left",
      width: 250,
      renderCell: RenderCellExpand,
    },
    {
      field: "creationDate",
      headerName: "Create Date",
      width: 150,
      headerAlign: "center",
      align: "center",
      format: 'DD-MM-yyyy',
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    { field: 'bq', headerName: 'billingQty', hide: true },
    { field: 'cDate', headerName: 'C date', hide: true },
    { field: 'bDate', headerName: 'b date', hide: true },
  ];

  React.useEffect(() => {
    const gridData= tableData &&
    tableData.map((item,index)=>{
               return({...item,
                billingDate: new Date(item.billingDate),
                creationDate: new Date(item.creationDate),
                bq: convertToCurrencyFormatQuantaty(item.billingQty),
                cDate:item.creationDate ? moment(new Date(item.creationDate)).format("DD-MM-YYYY") : "",
                bDate:item.billingDate ? moment(new Date(item.billingDate)).format("DD-MM-YYYY") : "",
              })
             })
             setGridData(gridData)
   }, [tableData]);
//export same as report starts here
const onExportClick=()=>{
  const url = `export/allocationInventory-billing`;
  setExportState("Exporting...");
  let filters={
    "productCode":props.itemDetails.productCode,
    "customerId":props.itemDetails.customerId,
    "billingMonths":props.itemDetails.billingMonth,
    "billingYear":props.itemDetails.billingYear,
    "expiryDate":props.itemDetails.expirationDate
  }
  Axios({
      method: "POST",
      url: API_URL_LMS + url,
      data: filters,
      headers: {
          "Content-Type": "application/json",
          "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
          "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
  })
      .then(async (response) => {
          setExportState("Export");
          setOpen(true);
          setFileUrl(response.data.data);
          exportExcelFile(response.data.data);
      })
      .catch((err) => { setExportState("Export");});
}


function exportExcelFile(file_url) {
setExportFiles([])
Axios({
    method: "GET", url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
    headers: {
        "Content-Type": "application/json",
        'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
        'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
    }
})
    .then(async (response) => {
        const newRes = Array.isArray(response.data.data) ? response.data.data : []
        setExportFiles(newRes)
    }).catch((err) => {
        // setExportState({ btnName: "EXPORT" });
    })
}
//export same as report ends here.

function modifyColumns(columns) {
  // columns = columns.filter(function(el) { return el.field != "actions"; });
  columns = columns.filter((item)=>!["actions","bq","cDate","bDate"].includes(item.field));
  return columns.map((item) => {
    return ({
      label: item.headerName,
      value: item.field,
      ...item
    })
  })
}

function modifyRows(rowdata) {
  // let filteredRow = searchedRows.map((item) => item.model)
  let filteredRow = rowdata.map((item) => item.model);
  const data = filteredRow.map((item) => {
    return ({
      ...item,
      // creationDate : item.creationDate ? new Date(item.creationDate) :""
    })
  })
  return data
}

function callExcelExport(data){
  const fileName = `Inventory_BillingList_Report_${moment(new Date()).format("DDMMyyyy")}`
  const sheetName = `Billing_List_Report_`
  onExportExcel(modifyColumns(columns), modifyRows(data), fileName,sheetName)
}

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={state.open}
        autoHideDuration={6000}
        key={"topright"}
      >
        <Alert
          severity={state.severity}
          sx={{ width: "100%" }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                setState({ open: false });
              }}
            >
              Close
            </Button>
          }
        >
          {state.message}
        </Alert>
      </Snackbar>

      <div
        className="ContactDataGridContainer"
      >
        <ExportExcelPopup
            title={"Customer"}
            fileName={"customer"}
            setOpen={setOpen}
            open={open}
            exportExcelFile={exportExcelFile}
            fileUrl={fileUrl}
            exportFiles={exportFiles}
        />
        <DataGridProMUI
          rows={gridData ? gridData : []}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // components={{
          //   Toolbar: CustomToolbar,
          // }}
          // rowsPerPageOptions={[25, 50, 75, 100]}
          // componentsProps={{
          //   toolbar: {
          //     showQuickFilter: true,
          //     quickFilterProps: { debounceMs: 500 },
          //   },
          // }}
          onExportClick={onExportClick}
          exportState={exportState}
          loading={loading}
          setSearchedRows={setSearchedRows}
          callExcelExport={callExcelExport}
          defaultStateChange={false}
        />
      </div>
      {/* popup is a reusable custom dialog component */}
      <Popup
        title={headerName}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        maxWidth={"xs"}
        p={3}
      >
        <AddDealer
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          setIsAddEdit={setIsAddEdit}
          subdealerNumber={subdealerNumber}
        />
      </Popup>
    </>
  );
};

export default AllocationInventoryList;
